<ng-template #data>
    <div class="overlay-container" [clickOutside]="root" (onClickOutside)="closeOnClickOutside && close()">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
</ng-template>